import * as types from './contactActionTypes';
import { ContactActionKeys as keys } from './contactActionKeys';
import { IContact, IDeactivateContactRequest } from './contactInterfaces';

export const contactActionCreators = {
  activateContact: (payload: IDeactivateContactRequest): types.ActivateContact => ({
    payload,
    type: keys.ACTIVATE_CONTACT
  }),
  addContacts: (contact: IContact): types.AddContact => ({
    payload: contact,
    type: keys.ADD_CONTACT
  }),
  addContactsFulfilled: (contact: IContact): types.AddContactFulfilled => ({
    payload: contact,
    type: keys.ADD_CONTACT_FULFILLED
  }),
  addContactsRejected: (): types.AddContactRejected => ({
    error: true,
    payload: '',
    type: keys.ADD_CONTACT_REJECTED
  }),
  deactivateContact: (payload: IDeactivateContactRequest): types.DeactivateContact => ({
    payload,
    type: keys.DEACTIVATE_CONTACT
  }),
  fetchContacts: (businessEntityId: number): types.FetchContacts => ({
    payload: businessEntityId,
    type: keys.FETCH_CONTACTS
  }),
  fetchContactsById: (contactIds: number[]): types.FetchContactsById => ({
    payload: { contactIds },
    type: keys.FETCH_CONTACTS_BY_ID
  }),
  fetchContactsFulfilled: (contacts: IContact[]): types.FetchContactsFulfilled => ({
    payload: contacts,
    type: keys.FETCH_CONTACTS_FULFILLED
  }),
  fetchContactsRejected: (): types.FetchContactsRejected => ({
    error: true,
    payload: '',
    type: keys.FETCH_CONTACTS_REJECTED
  }),
  processContacts: (contacts: IContact[]): types.ProcessContacts => ({
    payload: contacts,
    type: keys.PROCESS_CONTACTS
  }),
  updateContacts: (contact: IContact): types.UpdateContact => ({
    payload: contact,
    type: keys.UPDATE_CONTACT
  }),
  updateContactsFulfilled: (contact: IContact): types.UpdateContactFulfilled => ({
    payload: contact,
    type: keys.UPDATE_CONTACT_FULFILLED
  }),
  updateContactsRejected: (): types.UpdateContactRejected => ({
    error: true,
    payload: '',
    type: keys.UPDATE_CONTACT_REJECTED
  })
};
